import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { IState, ISuccessAction, IFailureAction } from 'interfaces/update-duck';

const { Types, Creators } = createActions(
  {
    request: ['putData', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['error'],
    reset: [],
  },
  { prefix: 'DELETE_MANY_CARRIER_CONTACT_' }
);

export interface DeleteManyCarrierContactState extends IState {}

const INITIAL_STATE: DeleteManyCarrierContactState = {
  loading: false,
  error: null,
};

const request = (state: DeleteManyCarrierContactState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: DeleteManyCarrierContactState,
  action: ISuccessAction
) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (
  state: DeleteManyCarrierContactState,
  action: IFailureAction
) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const deleteManyCarrierContact = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const DeleteManyCarrierContactTypes = Types;
export const DeleteManyCarrierContactActions = Creators;
